/* eslint-disable @typescript-eslint/ban-types */
export class AtsObject {
	public static deepValue = (obj: any, nestedKey: string | string[]): string => {
		let keys: string[];

		if (typeof nestedKey === 'string') {
			keys = nestedKey.includes('.') ? [...(nestedKey as string).split('.')] : [nestedKey as string];
		} else {
			keys = nestedKey as string[];
		}

		let returnVal = obj;

		keys.forEach(key => {
			returnVal = returnVal[key] ? returnVal[key] : returnVal;
		});
		return returnVal.toString();
	};

	public static hasProperties = (obj: any, nestedKey: string | string[]): string => {
		let keys: string[];

		if (typeof nestedKey === 'string') {
			keys = nestedKey.includes('.') ? [...(nestedKey as string).split('.')] : [nestedKey as string];
		} else {
			keys = nestedKey as string[];
		}

		let returnVal = obj;

		keys.forEach(key => {
			returnVal = returnVal[key] ? returnVal[key] : returnVal;
		});
		return returnVal.toString();
	};

	public static deepCopy<T>(inObject: { [key: string | number]: any } | T[]): object | T[] {
		let outObject: { [key: string | number]: any } | T[], value: object | T[];

		if (typeof inObject !== 'object' || inObject === null) {
			return inObject; // Return the value if inObject is not an object
		}

		const isArray: boolean = Array.isArray(inObject);

		// Create an array or object to hold the values
		outObject = isArray ? [] : {};

		for (const key in inObject) {
			if (key) {
				value = inObject[key];

				// Recursively (deep) copy for nested objects, including arrays
				outObject[key] = AtsObject.deepCopy(value);
			}
		}

		return outObject;
	}

	public static deepCompare(x: any, y: any): boolean {
		const ok = Object.keys,
			tx = typeof x,
			ty = typeof y;
		return x && y && tx === 'object' && tx === ty
			? ok(x).length === ok(y).length && ok(x).every(key => AtsObject.deepCompare(x[key], y[key]))
			: x === y;
	}
}
